<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div class="header">
        <div class="headWrap">
          <h1 class="title">Keywords</h1>
          <p class="subtitle" style="font-size: 16px">
            Keywords present on every Voice+ system&nbsp;
            <b-tooltip label="These keywords are 'triggerable' on every Voice+ call (unless disabled by the customer)" multilined position="is-bottom">
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </p>
        </div>
        <div class="buttonsGroup">
          <b-tooltip label="Add a Keyword" position="is-bottom"
            ><button class="button is-medium is-info" @click="isNewItemActive = true">
              <b-icon icon="plus" size="is-small"></b-icon></button
          ></b-tooltip>
          <b-tooltip label="Edit selected Keyword" position="is-bottom"
            ><button class="button is-medium is-info" @click="OpenEditItem()">
              <b-icon icon="pencil" size="is-small"></b-icon></button
          ></b-tooltip>
          <b-tooltip label="Delete a Keyword" position="is-left"
            ><button class="button is-medium is-danger" @click="DeleteItem()">
              <b-icon icon="trash" size="is-small"></b-icon></button
          ></b-tooltip>
        </div>
      </div>

      <template v-if="loaded">
        <b-table :data="this.keywords" :selected.sync="selected" :loading="this.isLoading" hoverable :default-sort="defaultSort">
          <b-table-column field="keyword" label="Keyword" v-slot="props" centered>
            {{ props.row.keyword }}
          </b-table-column>
          <b-table-column field="action" label="Action" v-slot="props" centered>
            {{
              actions.filter((action) => {
                return action.action_id === props.row.action_id;
              })[0].action_name
            }}
          </b-table-column>
          <b-table-column field="context" label="Context" v-slot="props" centered>
            {{
              contexts.filter((context) => {
                return context.context_id === props.row.context_id;
              })[0].context_name
            }}
          </b-table-column>
          <b-table-column field="enabled" label="Enabled" v-slot="props" centered>
            <template v-if="props.row.default">
              <b-checkbox :value="!props.row.disabled" v-on:input="defaultCheckboxTicket(props.row)"></b-checkbox>
            </template>
            <template v-else>
              <div v-if="props.row.enabled == 1">Yes</div>
              <div v-else>No</div>
            </template>
          </b-table-column>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                </p>
                <p>Looks like there aren't any Keywords</p>
              </div>
            </section>
          </template>
        </b-table>
        <b-modal :active.sync="isNewItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <new-item @submitted="AddNewItem" :heading="'New keyword'" :selected="this.formProps" :contexts="this.contexts" :actions="this.actions"></new-item>
        </b-modal>
        <b-modal :active.sync="isEditItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <new-item @submitted="EditItem" :heading="'Edit keyword'" :selected="this.editableSelected" :contexts="this.contexts" :actions="this.actions"></new-item>
        </b-modal>
      </template>
    </div>
  </div>
</template>
<script>
const axios = require("axios");

const NewItem = {
  props: {
    selected: {
      type: Object,
      required: false,
    },
    heading: {
      type: String,
      required: true,
    },
    contexts: {
      type: Array,
      required: false,
    },
    actions: {
      type: Array,
      required: false,
    },
  },
  methods: {
    submit: function () {
      this.$emit("submitted");
    },
  },
  template: `
        <form action="#" v-on:submit.prevent="submit">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{ heading }}</p>
                    </header>
                    <section class="modal-card-body">

                        <b-field label="Keyword">
                            <b-input
                                type="text"
                                placeholder="e.g. operator"
                                v-model="selected.keyword"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Context">
                            <b-select v-model="selected.context_id" placeholder="Select a context" required>
                                <option
                                    v-for="context in this.contexts"
                                    :value="context.context_id"
                                    :key="context.context_id">
                                    {{ context.context_name }}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field label="Action">
                            <b-select v-model="selected.action_id" placeholder="Select a action" required>
                                <option
                                    v-for="action in this.actions"
                                    :value="action.action_id"
                                    :key="action.action_id">
                                    {{ action.action_name }}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field label="Custom Message" v-if="selected.action == 'operator_custom'" required>
                            <b-input
                                type="text"
                                v-model="selected.action_addition"
                                required>
                            </b-input>
                        </b-field>
                        <b-field label="Enabled">
                            <b-checkbox
                                v-model="selected.enabled"
                                :true-value="1"
                                :false-value="0">
                            </b-checkbox>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="$parent.close()">Cancel</button>
                        <button class="button is-primary" type="submit">Submit</button>
                    </footer>
                </div>
            </form>
        `,
};

export default {
  components: {
    NewItem,
  },
  data: function () {
    return {
      loaded: false,
      keywords: [],
      isNewItemActive: false,
      isEditItemActive: false,
      editableSelected: {},
      contexts: [],
      apiUrl: "https://api.jeak.co.uk",
      selected: {},
      isLoading: true,
      defaultSort: "",
      formProps: {
        action_id: 0,
        context_id: 0,
        keyword: "",
        enabled: "0",
      },
      actions: [],
    };
  },
  methods: {
    GetKeywords: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.get(this.apiUrl + `/keywords`, config).then((response) => {
        this.keywords = response.data;
        this.isLoading = false;
        this.loaded = true;
      });
    },
    GetContexts: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.get(this.apiUrl + `/keywords/contexts`, config).then((response) => {
        this.contexts = response.data;
      });
    },
    GetActions: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.get(this.apiUrl + `/keywords/actions`, config).then((response) => {
        this.actions = response.data;
      });
    },
    EditItem: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.put(this.apiUrl + `/keywords/${this.editableSelected.id}`, this.editableSelected, config).then((response) => {
        this.isEditItemActive = false;
        this.GetKeywords();
      });
    },
    AddNewItem: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.post(this.apiUrl + `/keywords`, this.formProps, config).then((response) => {
        this.isNewItemActive = false;
        this.GetKeywords();
      });
    },
    DeleteItem: async function () {
      this.$buefy.dialog.confirm({
        title: "Deleting Keyword",
        message: "Are you sure you want to <b>delete</b> this keyword? This action cannot be undone.",
        confirmText: "Delete Keyword",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          const token = this.$cognitoAuth.getIdToken();
          const config = {
            headers: { Authorization: `Bearer ` + token },
          };
          axios.delete(this.apiUrl + `/keywords/${this.selected.id}`, config).then((response) => {
            this.GetKeywords();

            this.$buefy.toast.open("Keyword deleted!");
          });
        },
      });
    },
    OpenEditItem() {
      Object.assign(this.editableSelected, this.selected);
      this.isEditItemActive = true;
    },
  },
  mounted() {
    this.GetContexts();
    this.GetActions();
    this.GetKeywords();
  },
};
</script>

<style scoped>
.container {
  margin-top: 20px;
}
#vapp {
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
.header .headWrap {
  grid-column: 1/6;
}
.buttonsGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
</style>
